"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sitesReducer = exports.cmsState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immer = _interopRequireDefault(require("immer"));

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var DEFAULT_STATE = {
  siteID: null,
  sites: {},
  deploymentImage: ''
};

var cmsState = _objectSpread({}, DEFAULT_STATE);

exports.cmsState = cmsState;

var sitesReducer = function sitesReducer(state, action) {
  var payload = action.payload;
  return (0, _immer.default)(state, function (draft) {
    switch (action.type) {
      case "SET_DEPLOYMENT_IMAGE":
        draft.deploymentImage = payload;
        break;

      /******************************
       * Sites
       ******************************/

      case "ADD_SITES":
        draft.sites = payload;
        break;

      case "ADD_SITE":
        draft.siteID = payload.id;
        (0, _lodash.set)(draft, "sites.".concat(payload.id), payload);
        break;

      case "ADD_SITE_SETTING":
        (0, _lodash.set)(draft, "sites.".concat(payload.id, ".").concat(payload.key), payload.value);
        break;

      case "DELETE_SITE":
        draft.siteID = null;
        delete draft.sites[payload.id];
        break;

      /******************************
       * Collections
       ******************************/

      case "ADD_COLLECTION":
        (0, _lodash.set)(draft, "sites.".concat(payload.siteID, ".postTypes.").concat(payload.id), payload);
        break;

      case "UPDATE_COLLECTION":
        (0, _lodash.set)(draft, "sites.".concat(payload.siteID, ".postTypes.").concat(payload.id), payload);
        break;

      case "DELETE_COLLECTION":
        delete draft.sites[payload.siteID].postTypes[payload.id];
        break;

      /******************************
       * Taxonomies
       ******************************/

      case "ADD_TAXONOMY":
        (0, _lodash.set)(draft, "sites.".concat(payload.siteID, ".taxonomies.").concat(payload.id), payload);
        break;

      case "UPDATE_TAXONOMY":
        (0, _lodash.set)(draft, "sites.".concat(payload.siteID, ".taxonomies.").concat(payload.id), payload);
        break;

      case "DELETE_TAXONOMY":
        delete draft.sites[payload.siteID].taxonomies[payload.id];
        break;

      /******************************
       * Terms
       ******************************/

      case "ADD_TERM":
        draft.sites[payload.siteID].taxonomies[payload.taxonomyID].terms.push(payload);
        break;

      case "UPDATE_TERM":
        var termIndex = draft.sites[payload.siteID].taxonomies[payload.taxonomyID].terms.findIndex(function (o) {
          return o.id === payload.id;
        });
        (0, _lodash.set)(draft, "sites.".concat(payload.siteID, ".taxonomies.").concat(payload.taxonomyID, ".terms.").concat(termIndex), payload);
        break;

      case "DELETE_TERM":
        draft.sites[payload.siteID].taxonomies[payload.taxonomyID].terms = draft.sites[payload.siteID].taxonomies[payload.taxonomyID].terms.filter(function (o) {
          return o.id !== parseInt(payload.id);
        });
        break;

      /******************************
       * Posts
       ******************************/

      case "ADD_POST":
        (0, _lodash.set)(draft, "sites.".concat(payload.siteID, ".postTypes.").concat(payload.postTypeID, ".posts.").concat(payload.id), payload);
        break;

      case "DELETE_POST":
        delete draft.sites[payload.siteID].postTypes[payload.postTypeID].posts[payload.id];
        break;

      /******************************
       * Media Items
       ******************************/

      case "ADD_MEDIA_ITEM":
        draft.sites[payload.siteID].mediaItems = {
          items: (0, _lodash.unionBy)([payload], draft.sites[payload.siteID].mediaItems.items, 'id'),
          page: draft.sites[payload.siteID].mediaItems.page
        };
        break;

      case "ADD_MEDIA_ITEMS":
        draft.sites[payload.siteID].mediaItems = {
          items: (0, _lodash.unionBy)(draft.sites[payload.siteID].mediaItems.items, payload.items, 'id'),
          page: payload.page
        };
        break;

      case "DELETE_MEDIA_ITEM":
        draft.sites[payload.siteID].mediaItems.items = draft.sites[payload.siteID].mediaItems.items.filter(function (o) {
          return o.id !== parseInt(payload.id);
        });
        break;

      /******************************
       * Users
       ******************************/

      case "ADD_USER":
        draft.sites[payload.siteID].users = {
          items: (0, _lodash.unionBy)([payload], draft.sites[payload.siteID].users.items, 'id'),
          page: draft.sites[payload.siteID].users.page
        };
        break;

      case "ADD_USERS":
        draft.sites[payload.siteID].users = {
          items: (0, _lodash.unionBy)(draft.sites[payload.siteID].users.items, payload.items, 'id'),
          page: payload.page
        };
        break;

      case "DELETE_USER":
        draft.sites[payload.siteID].users.items = draft.sites[payload.siteID].users.items.filter(function (o) {
          return o.id !== payload.id;
        });
        break;

      /******************************
       * Clear
       ******************************/

      case "CLEAR_POST_STATE":
        draft.siteID = null;
        draft.sites = {};
        break;

      default:
    }
  });
};

exports.sitesReducer = sitesReducer;